const ReceiveIcon = ({ ...props }) => {
  const { color = 'var(--pcm-body-color)' } = props;
  return (
    <svg width='17' height='17' viewBox='0 0 17 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M9.76502 12.4105C9.16459 13.1925 7.98597 13.1925 7.38555 12.4105L4.72435 8.94469C3.96679 7.95808 4.67018 6.53116 5.91408 6.53116L11.2365 6.53116C12.4804 6.53116 13.1838 7.95808 12.4262 8.94469L9.76502 12.4105Z'
        fill={color}
      />
      <path d='M8.5752 8.1626V2.00016V8.1626Z' fill={color} />
      <path d='M8.5752 8.1626V2.00016' stroke={color} strokeWidth='2' strokeLinecap='round' />
      <path d='M12.194 15.0952H4.95667H12.194Z' fill={color} />
      <path d='M12.194 15.0952H4.95667' stroke={color} strokeWidth='2' strokeLinecap='round' />
    </svg>
  );
};

export default ReceiveIcon;
